import React from 'react';
import PresskitButton from './PresskitButton.component';
import {Card} from 'react-bootstrap';

function PresskitCard({data})
{
  return(
    <Card id = "presskitCard"
    text={'white'}
    style={{ width: '18rem' }}
    className="mb-2">
    <img id = "cardImg" src = {data.cardimage}></img>
    <Card.Body>
      <Card.Title id = "carteronetext">{data.game} </Card.Title>
      <Card.Text id = "cardparagraph">
        {data.carddescription}
      </Card.Text>
    </Card.Body>
    <PresskitButton data = {data}/>
  </Card>
  )
}

export default PresskitCard;
